import {
  AllAllowedCookies,
  AllAllowedCookiesForPanel,
  AllowedFunctionalCookies,
  AllowedFunctionalCookiesForPanel,
  AllowedMarketingCookies,
  AllowedParam,
} from 'models/cookies'

export const allowedMarketingCookies: AllowedMarketingCookies[] = [
  'refererCode',
  'utm_source',
  'utm_campaign',
  'utm_medium',
  'utm_term',
  'utm_content',
  'ref',
  'refvis',
  'uap',
  'bankiervis',
]

export const allowedFunctionalCookies: AllowedFunctionalCookies[] = ['language', 'promo_popup', 'promoPopup__showed']

export const allAllowedCookies: AllAllowedCookies[] = [...allowedMarketingCookies, ...allowedFunctionalCookies]

export const allowedFunctionalCookiesForPanel: AllowedFunctionalCookiesForPanel[] = ['language']
export const allAllowedCookiesForPanel: AllAllowedCookiesForPanel[] = [
  ...allowedMarketingCookies,
  ...allowedFunctionalCookiesForPanel,
]

//! Order is important, SDIKWT-2000
export const allowedUtmParams: AllowedParam[] = [
  { name: 'utm_source', type: 'string' },
  { name: 'utm_medium', type: 'string' },
  { name: 'utm_term', type: 'string' },
  { name: 'utm_content', type: 'string' },
  { name: 'utm_campaign', type: 'string' },
]

export const allowedPartnerParams: AllowedParam[] = [
  { name: 'at_gd', type: 'string' },
  { name: 'xchangerId', type: 'string' },
  { name: 'bankierID', type: 'string' },
  { name: 'clickId', type: 'string' },
  { name: 'uap', type: 'string' },
]

export const refvisParams: AllowedParam[] = [
  { name: 'ref', type: 'string' },
  ...allowedUtmParams,
  ...allowedPartnerParams,
]

export const allowedReferalParams: AllowedParam[] = [
  ...allowedUtmParams,
  ...allowedPartnerParams,
  { name: 'ref', type: 'string' },
  { name: 'refererCode', type: 'string' },
]

export const allowedParamsIds: AllowedParam[] = [
  { name: 'promo_popup', type: 'boolean' },
  { name: 'promoPopup__showed', type: 'boolean' },
]
